<template>
  <div class="f360-accordion">
    <div
      class="f360-accordion__title"
      :class="{
        'f360-accordion__title--expanded': isCollapsed,
        'f360-accordion__title--error': error
      }"
      @click="toggleCollapse"
    >
      <h2>{{ title }}</h2>

      <span class="f360-accordion__toggle">
        <span class="f360-accordion__error" v-if="error">{{ error }}</span>
        <MaterialIcon
          icon="keyboard_arrow_down"
          class="f360-accordion__icon"
          :class="{ 'f360-accordion__icon--expanded': isCollapsed }"
        />
      </span>
    </div>

    <div class="f360-accordion__wrapper">
      <div class="f360-accordion__content" v-show="isCollapsed">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

const props = defineProps<{
  title: string;
  error?: string;
  isOpen?: boolean;
}>();

const emit = defineEmits<{
  toggle: [isOpen: boolean];
}>();

const isCollapsed = ref<boolean>(props.isOpen || false);

function toggleCollapse() {
  isCollapsed.value = !isCollapsed.value;
  emit('toggle', isCollapsed.value);
}
</script>

<style scoped lang="scss">
@use "@/ui/styles/variables" as *;
@use "@/ui/styles/theme/f360-theme" as *;

.f360-accordion {
  &__title {
    cursor: pointer;
    padding: 8px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: $font-color;
    border-radius: 5px;
    transition: all 0.3s ease;

    &:hover {
      background-color: #edf7ff;
    }

    &--expanded {
      color: $font-color-f360 !important;
    }

    &--error {
      color: #ed1517 !important;
    }

    h2 {
      margin: 0;
      font-family: $fontFamily;
      font-weight: 700;
      font-size: 14px;
      line-height: 16px;
    }
  }

  &__toggle {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__error {
    background-color: #fff1f1;
    padding: 0px 8px;
    border-radius: 5px;
    height: 24px;
    font-family: $fontFamily;
    font-weight: 400;
    font-size: 12px;
    line-height: 24px;
  }

  &__icon {
    font-size: 24px;
    color: inherit;
    transition: transform 0.3s ease;

    &--expanded {
      transform: rotate(-180deg);
    }
  }

  &__content {
    transition: height 0.3s ease;
    overflow: hidden;
    height: auto;
    margin-top: 4px;
  }
}
</style>
